import React from 'react';
import { Typography, Skeleton, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import TagList from './TagList';
import styles from '../Profile.module.css';

const { Title } = Typography;

interface PersonalitySectionProps {
  personalities: string[];
  isLoading: boolean;
}

const PersonalitySection: React.FC<PersonalitySectionProps> = ({ personalities, isLoading }) => {
  const { t } = useTranslation();

  // Don't render if no personalities available
  if (!isLoading && (!personalities || personalities.length === 0)) {
    return null;
  }

  return (
    <Card className={styles.sectionCard} bordered={false}>
      <Title level={4} className={styles.sectionTitle}>
        {t('#Profile.personality')}
      </Title>

      <Skeleton loading={isLoading} paragraph={{ rows: 2 }} active>
        <TagList items={personalities} />
      </Skeleton>
    </Card>
  );
};

export default PersonalitySection;